import Treatment from "./Treatment";
function Treatments({ treatments }) {
  return (
    <div className="shadow card mt-4">
      <div className="card-body">
        <h5 className="card-title">Treatments</h5>
        {treatments &&
          treatments.map((treat) => (
            <Treatment key={treat} name={treat[0]} date={treat[1]} />
          ))}
      </div>
    </div>
  );
}

export default Treatments;
